'use client';

import { useEffect, useState } from 'react';

const AUTO_HIDE_WINDOW_AFTER_X_SECONDS = 3;

export const useAutohide = () => {
  const [isHidden, setIsHidden] = useState(true);
  const [, setCountDown] = useState<number>(AUTO_HIDE_WINDOW_AFTER_X_SECONDS);

  useEffect(() => {
    const keepWindowOpen = () => {
      setIsHidden(false);
      setCountDown(AUTO_HIDE_WINDOW_AFTER_X_SECONDS);
    };
    document.addEventListener('mousemove', keepWindowOpen);
    document.addEventListener('touchmove', keepWindowOpen);
    document.addEventListener('touchstart', keepWindowOpen);
    document.addEventListener('click', keepWindowOpen);
    document.addEventListener('scroll', keepWindowOpen);
    document.addEventListener('wheel', keepWindowOpen);
    return () => {
      document.removeEventListener('mousemove', keepWindowOpen);
      document.removeEventListener('touchmove', keepWindowOpen);
      document.removeEventListener('touchstart', keepWindowOpen);
      document.removeEventListener('click', keepWindowOpen);
      document.removeEventListener('scroll', keepWindowOpen);
      document.removeEventListener('wheel', keepWindowOpen);
    };
  }, []);

  useEffect(() => {
    if (isHidden) return;
    // auto hide when user is not active
    const interval = setInterval(() => {
      setCountDown((prevState) => {
        const countDown = prevState - 1;
        if (countDown === 0) {
          setIsHidden(true);
          return 0;
        }
        return prevState - 1;
      });
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [isHidden]);

  return { isHidden, setIsHidden };
};
